
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/photos",
      function () {
        return require("private-next-pages/photos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/photos"])
      });
    }
  